import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createProductSchemas } from 'shared/db/validation/schemas/product';
import { Validator } from 'shared/db/validation/validator';
import { ProductRawRecord } from 'shared/types/Products';
import { DeleteRawRecord, UpdateRawRecord } from 'shared/types/rawRecordFields';
import { ProductEntityDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createProductSchemas();

const addValidator = createDBEntityValidator<ProductRawRecord>(schemas.add);
const updateValidator = createDBEntityValidator<
    UpdateRawRecord<ProductRawRecord>
>(schemas.update);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-products'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createProductsInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const productsInputValidation: ProductEntityDBValidation = {
    add: createProductsInputValidation(addValidator, validationStrategy),
    update: createProductsInputValidation(updateValidator, validationStrategy),
    delete: createProductsInputValidation(deleteValidator, validationStrategy),
};
